import { useAuth } from "../../api/auth/useAuth";

export function useChatAccess() {
  const { isLogged, self } = useAuth();
  return Boolean(isLogged && (self?.is_synota_admin || self?.is_synota_readonly_admin));
}
